export default "__VITE_ASSET__BeESMySA__"